import { CartModel } from '@/models';

export const useCollapsableDetails = (params: HookParams) => {
  const { isUsa, t, cartContent } = params;

  const shouldShow = !isUsa;

  const totalHT = {
    label: t('account.orders.details.totalHt') + ' :',
    value: cartContent.totalProductHT
  };

  const totalTTC = {
    label: t('account.orders.details.TVA') + ' :',
    value: cartContent.totalTVA
  };

  return {
    shouldShow, totalHT, totalTTC
  };
};

type HookParams = {
  isUsa: boolean;
  t: (key: string) => string;
  cartContent: CartModel;
}
